import React, { Component } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
// UI
import styles from './main.scss'
import { graphql, StaticQuery } from 'gatsby'

const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null
}

class ProgressBar extends Component {
  get progress() {
    const { total, current } = this.props

    return (current / total) * 100
  }

  get rgbBg() {
    return hexToRgb(this.bgColor)
  }

  get bgColor() {
    return get(this.props.data, 'campaignData.themeId.buttonBackgroundColor')
  }

  render() {
    if (!get(this.props.data, 'campaignData.showProgressBar')) {
      return null
    }

    if (this.props.total <= 1) {
      return null
    }

    if (typeof window === `undefined`) {
      return null
    }

    return (
      <div className={styles.progressBarWrapper}
           style={{ backgroundColor: `rgba(${this.rgbBg.r}, ${this.rgbBg.g}, ${this.rgbBg.b}, .2)` }}>
        <div className={styles.progress} style={{
          width: `${this.progress}%`,
          backgroundColor: this.bgColor,
        }}/>
      </div>
    )
  }
}

ProgressBar.propTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          _id
          showProgressBar
          themeId {
            buttonBackgroundColor
          }
        }
      }
    `}
    render={data => <ProgressBar data={data} {...props} />}
  />
)
